export default {
  init() {
    const letters = $('#glossary-letters li');
    const that = this;

    letters.on('click', function () {
      that.showLetter($(this).data('letter'));
    });

    if (window.location.hash) {
      this.showLetter(window.location.hash.replace('#', ''));
    }
  },

  showLetter(letter) {
    if (!$(`.glossary-letter[data-letter="${letter}"`).length) {
      window.location.replace('/glossary/#' + letter);
      return;
    }

    $('.glossary-letter').hide();
    $(`.glossary-letter[data-letter="${letter}"`).fadeIn('slow');
    window.location.replace('/glossary/#' + letter);
  },
};
